import * as React from 'react';
import Modal from 'react-bootstrap/Modal';

interface NotesPopupProps {
    showEditNotesModal: boolean;
    editNotes: EditNotes;
    hideNotes(): void;
    updateNotes(notes: EditNotes): void;
    saveNotes(): void;
}

interface NotesPopup {
    
}

interface EditNotes {
    heading: string;
    rowIndex: number;
    parentIndex: number;
    id: number;
    itemId: number;
    item: string;
    notes: string;
}


export default class NotePopup extends React.Component<NotesPopupProps, NotesPopup> {
    constructor(props: any) {
        super(props);

        this.state = {

            
        };

    }

    handleChange = (e: any) => {
        var editNotes: EditNotes = this.props.editNotes;
        editNotes.notes = e.target.value;

        this.props.updateNotes(editNotes);
    }

    hideEditNotesModal = () => {
        this.props.hideNotes();
    }

    saveEditNotes = () => {
        this.props.saveNotes();
    }

    render() {
        let contents = this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let heading = this.props.editNotes.heading == "" ? "Edit Notes" : this.props.editNotes.heading;

        return (
            <Modal show={this.props.showEditNotesModal} onHide={this.hideEditNotesModal}>
                <Modal.Header className="modal__header--colour">
                    <Modal.Title>{heading}</Modal.Title>
                    <button type="button" className="close" onClick={this.hideEditNotesModal}>&times;</button>
                </Modal.Header>
                <Modal.Body>
                    <label className="input-group input-group__max--width" htmlFor="editNotes">
                        <span className="label">Notes</span>
                        <textarea className="notes--height" id="editNotes" name="notes" value={this.props.editNotes.notes} onChange={(e) => this.handleChange(e)}></textarea>
                    </label>
                </Modal.Body>
                <Modal.Footer>
                    <button className="popup-button--yes" onClick={this.saveEditNotes}>Save</button>
                </Modal.Footer>
            </Modal>

        )
    }

}